import { render, staticRenderFns } from "./FeedConfig.vue?vue&type=template&id=410dc96a&scoped=true"
import script from "./FeedConfig.vue?vue&type=script&lang=js"
export * from "./FeedConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410dc96a",
  null
  
)

export default component.exports